import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';
import { ARTICLE_SERVICE_TYPES } from '@/models/article';

import { type ConditionFormQuestion } from '../ConditionQuestion';

export const ServiceTypesReadonly = ({ question }: { question: ConditionFormQuestion }) => {
  const { i18n } = useLingui();

  return (
    <Paragraph>
      <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.service-types">
        Service types:
      </Trans>{' '}
      <InlineText weight="medium">
        {question.serviceChoices.length ? (
          question.serviceChoices
            .map((serviceChoice) => {
              const serviceType = ARTICLE_SERVICE_TYPES.find(
                (articleServiceType) => articleServiceType.id === serviceChoice
              )!;

              return i18n._(serviceType.label);
            })
            .join(', ')
        ) : (
          <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.service-types.all">
            All
          </Trans>
        )}
      </InlineText>
    </Paragraph>
  );
};
